import { render, staticRenderFns } from "./VerificationDetailsSidebar.vue?vue&type=template&id=6bb5d6f8&"
import script from "./VerificationDetailsSidebar.vue?vue&type=script&lang=js&"
export * from "./VerificationDetailsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports